class BlockStoriesBlockMembers {
	constructor() {
		document.querySelectorAll(".block-stories, .block-members").forEach(elem => {
			const pin = elem.querySelector(".pin-container");
			const scroller = elem.querySelector(".horizontal-slide");

			if (scroller.querySelectorAll(".card").length > 3) {
				gsap.to(scroller, {
					x: -this.getDuration(scroller),
					ease: "power1.inOut",
					scrollTrigger: {
						trigger: scroller,
						start: "center center",
						end: () => `+=${this.getDuration(scroller) * 1.5}`,
						scrub: true,
						anticipatePin: 1,
						pin: pin,
					}
				});

				setTimeout(() => {
					ScrollTrigger.refresh();
				}, 1000);
			}
		});
	}

	getDuration(scroller) {
		const cards = scroller.querySelectorAll(".card");
		const cardWidth = cards[0].clientWidth;
		const cardsCount = cards.length;
		const gap = 30;
		const blockWidth = scroller.clientWidth;
		const totalWidth = cardWidth * cardsCount + gap * cardsCount - gap + 180;
		const duration = totalWidth - blockWidth;
		return duration;
	}
}
